
  import { defineComponent, ref, computed } from 'vue';
  import { useI18n } from 'vue-i18n/index';
  import { reinitializeComponents } from '@/core/plugins/keenthemes';
  import { useStore } from 'vuex';
  import { Actions } from '@/store/enums/StoreEnums';
  import LookupNameIds from '@/store/enums/settingsEnums';
  import SearchField from '@/components/common/SearchField.vue';

  export default defineComponent({
    name: 'horse-filter',
    emit: ['filter-selected', 'reset'],
    components: {
      SearchField,
    },
    async setup(props, { emit }) {
      const { t, te } = useI18n();
      const store = useStore();
      const selectedItems = ref({
        horseId: '',
        statusId: '',
        horseCategoryId: '',
        passportNumber: '',
        horseTypeId: '',
        horseLocationId: '',
      });
      const translate = (text) => {
        if (te(text)) {
          return t(text);
        } else {
          return text;
        }
      };

      const onSubmit = () => {
        emit('filter-selected', selectedItems.value);
      };

      const onReset = () => {
        selectedItems.value = {
          horseId: '',
          statusId: '',
          horseCategoryId: '',
          passportNumber: '',
          horseTypeId: '',
          horseLocationId: '',
        };
        emit('reset', selectedItems.value);
      };
      const lookupsList = computed(() => store.getters.allLookupsList);
      const horseLocationList = computed(() => store.getters.allLocationsList);
      const PaymentIncicators = computed(() => {
        return lookupsList.value.filter(
          (lookup) => lookup.lookupNameId === LookupNameIds.PAYMENT_INDICATOR
        );
      });
      const statuses = computed(() =>
        lookupsList.value.filter((lookup) => {
          return lookup.lookupNameId === LookupNameIds.STATUS;
        })
      );
      const categoryList = lookupsList.value.filter((lookup) => {
        return lookup.lookupNameId === LookupNameIds.HORSE_CATEGORY;
      });
      const horseTypeList = lookupsList.value.filter((lookup) => {
        return lookup.lookupNameId === LookupNameIds.HORSE_TYPE;
      });

      await store.dispatch(Actions.GET_ALL_SETTINGS_HORSE_LOCATIONS);

      reinitializeComponents();

      return {
        onSubmit,
        onReset,
        selectedItems,
        translate,
        categoryList,
        horseTypeList,
        horseLocationList,
        PaymentIncicators,
        statuses,
        horseList: store.getters.allHorsesList,
      };
    },
  });
